import * as React from 'react'

export function IconChrome(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 80 80" {...props}>
      <path
        fill="#FFF"
        d="M21.21 33.791L8.887 14.856C16.565 5.307 28.081.049 39.855 0c6.822-.048 13.79 1.694 20.129 5.355 7 4.064 12.322 9.903 15.71 16.613L42.58 20.227c-9.371-.549-18.29 4.726-21.371 13.564zm5.306 6.21c0 7.452 6.032 13.484 13.484 13.484S53.484 47.453 53.484 40 47.452 26.517 40 26.517a13.468 13.468 0 00-13.484 13.484zm50.79-14.387l-22.532 1.161c6.113 7.145 6.21 17.452 1.065 25.355l-18.08 27.806c7.5.404 15.225-1.241 22.225-5.306 17.322-10 24.339-30.968 17.322-49.016zM21.565 47.678L6.516 18.082A39.97 39.97 0 000 40c0 20 14.645 36.564 33.79 39.5l10.275-20.13c-9.29 1.743-18.259-3.354-22.5-11.693z"
      />
    </svg>
  )
}

export function IconFirefox(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 80 83" {...props}>
      <path
        fill="#FFF"
        d="M77.057 27.679c-1.739-4.18-5.259-8.689-8.023-10.12 2.25 4.408 3.553 8.833 4.05 12.131 0 0 0 .023.008.067-4.522-11.27-12.189-15.814-18.451-25.71-.316-.5-.633-1.001-.941-1.529a9.979 9.979 0 01-.441-.828 7.357 7.357 0 01-.597-1.577.103.103 0 00-.09-.108.148.148 0 00-.075 0l-.02.011-.03.017.017-.023c-8.89 5.208-12.577 14.324-13.525 20.128a21.311 21.311 0 00-7.923 2.021c-.468.232-.686.78-.506 1.27.181.524.753.802 1.277.622l.085-.035a19.318 19.318 0 016.903-1.803l.233-.016c.328-.02.656-.033.984-.036a20.1 20.1 0 015.746.79c.11.033.216.069.328.103a18.365 18.365 0 011.585.566c.179.072.357.144.533.221a25.41 25.41 0 011.188.57 19.225 19.225 0 011.269.727 20.474 20.474 0 016.993 7.234c-2.13-1.5-5.959-2.982-9.642-2.34 14.383 7.19 10.521 31.95-9.408 31.016a17.775 17.775 0 01-5.204-1.004c-.396-.149-.787-.31-1.173-.48a11.616 11.616 0 01-.676-.328c-4.892-2.515-8.924-7.282-9.428-13.074 0 0 1.845-6.877 13.217-6.877 1.23 0 4.742-3.43 4.808-4.426-.015-.328-6.974-3.093-9.687-5.767-1.45-1.428-2.14-2.117-2.75-2.633-.329-.28-.674-.541-1.034-.782a18.533 18.533 0 01-.113-9.775c-4.108 1.87-7.303 4.828-9.624 7.437h-.02c-1.585-2.008-1.475-8.63-1.382-10.013-.02-.087-1.184.604-1.336.707-1.399 1-2.706 2.12-3.908 3.349a35.082 35.082 0 00-3.733 4.48 33.744 33.744 0 00-5.366 12.115c-.01.044-.382 1.674-.655 3.685-.046.314-.089.628-.128.941-.094.605-.164 1.264-.236 2.295 0 .04 0 .079-.008.118-.03.445-.056.887-.08 1.332v.203c0 22.082 17.902 39.982 39.986 39.982 19.777 0 36.2-14.358 39.415-33.217.067-.511.121-1.026.182-1.542.795-6.858-.089-14.064-2.594-20.09v-.005z"
      />
    </svg>
  )
}

export function IconTypewriter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 80 86" {...props}>
      <g fill="none">
        <path
          fill="#48587C"
          d="M67.508 60.98c0 2.263-1.82 4.097-4.066 4.097H10.578c-2.246 0-4.067-1.834-4.067-4.096V21.385c0-2.263 1.82-4.097 4.067-4.097h52.864c2.246 0 4.066 1.834 4.066 4.097V60.98z"
        />
        <path fill="#A7A7A7" d="M78.676 42.182a4.132 4.132 0 11-8.264 0v-4.785a4.132 4.132 0 118.264 0v4.785z" />
        <path
          fill="#FFF"
          d="M61.442 51.234V6.231c0-2.717-2.193-4.92-4.898-4.92H17.476c-2.705 0-4.899 2.203-4.899 4.92v45.003h48.865z"
        />
        <path
          fill="#FFF"
          d="M61.442 51.234V6.231c0-2.717-2.193-4.92-4.898-4.92H17.476c-2.705 0-4.899 2.203-4.899 4.92v45.003h48.865z"
        />
        <path
          fill="#000"
          d="M17.033 9.192c0-2.717 2.193-4.92 4.899-4.92h39.067l.04.001a4.9 4.9 0 00-4.495-2.961H17.476c-2.705 0-4.899 2.202-4.899 4.92v45.002h4.456V9.192z"
          opacity=".1"
        />
        <path
          d="M48.38 22.486H25.64c-.692 0-1.253.564-1.253 1.258 0 .695.56 1.259 1.253 1.259h22.74c.692 0 1.253-.564 1.253-1.259 0-.694-.56-1.258-1.254-1.258zm-22.74-3.094h22.74c.692 0 1.253-.564 1.253-1.259s-.56-1.258-1.254-1.258H25.64c-.692 0-1.253.563-1.253 1.258 0 .695.56 1.259 1.253 1.259zm0-5.682h11.37c.692 0 1.253-.564 1.253-1.26 0-.694-.56-1.258-1.253-1.258H25.64c-.692 0-1.253.564-1.253 1.259s.56 1.258 1.253 1.258z"
          fill="#B3B3B3"
        />
        <path
          fill="#F1F1F1"
          d="M72.695 79.586c0 2.647-2.13 4.793-4.758 4.793H6.083c-2.628 0-4.758-2.146-4.758-4.793v-46.33c0-2.647 2.13-4.793 4.758-4.793h61.854c2.628 0 4.758 2.146 4.758 4.793v46.33z"
        />
        <path
          fill="#FFF"
          d="M67.937 28.463H64.28c2.628 0 4.758 2.146 4.758 4.793v46.33c0 2.647-2.13 4.793-4.758 4.793h3.658c2.628 0 4.758-2.146 4.758-4.793v-46.33c0-2.647-2.13-4.793-4.758-4.793z"
          opacity=".2"
        />
        <path
          fill="#000"
          d="M6.779 79.586v-46.33c0-2.647 2.13-4.793 4.758-4.793H6.083c-2.628 0-4.758 2.146-4.758 4.793v46.33c0 2.647 2.13 4.793 4.758 4.793h5.454c-2.628 0-4.758-2.146-4.758-4.793z"
          opacity=".1"
        />
        <path
          fill="#8A8A8A"
          d="M66.78 75.02a3.05 3.05 0 01-3.043 3.057H10.282a3.05 3.05 0 01-3.042-3.058V50.851a3.05 3.05 0 013.042-3.057h53.455a3.05 3.05 0 013.043 3.057v24.168z"
        />
        <path
          fill="#000"
          d="M13.942 74.447a3.05 3.05 0 01-3.042-3.058V47.794h-.618A3.05 3.05 0 007.24 50.85v24.168a3.05 3.05 0 003.042 3.058h53.455a3.05 3.05 0 003.042-3.058v-.572H13.942z"
          opacity=".1"
        />
        <path
          d="M15.223 54.932v-3.02a.753.753 0 00-.751-.755h-3.005a.753.753 0 00-.752.755v3.02c0 .417.336.755.752.755h3.005c.415 0 .75-.338.75-.755zm2.253.755h3.006a.753.753 0 00.751-.755v-3.02a.753.753 0 00-.751-.755h-3.006a.753.753 0 00-.75.755v3.02c0 .417.336.755.75.755zm6.011 0h3.005a.753.753 0 00.752-.755v-3.02a.753.753 0 00-.752-.755h-3.005a.753.753 0 00-.752.755v3.02c0 .417.337.755.752.755zm6.01 0h3.005a.753.753 0 00.752-.755v-3.02a.753.753 0 00-.752-.755h-3.005a.753.753 0 00-.751.755v3.02c0 .417.336.755.75.755zm6.01 0h3.006a.753.753 0 00.75-.755v-3.02a.753.753 0 00-.75-.755h-3.006a.753.753 0 00-.751.755v3.02c0 .417.336.755.751.755zm6.01 0h3.006a.753.753 0 00.751-.755v-3.02a.753.753 0 00-.751-.755h-3.006a.753.753 0 00-.751.755v3.02c0 .417.337.755.751.755zm6.011 0h3.005a.753.753 0 00.751-.755v-3.02a.753.753 0 00-.751-.755h-3.005a.753.753 0 00-.752.755v3.02c0 .417.337.755.752.755zm6.01 0h3.005a.753.753 0 00.751-.755v-3.02a.753.753 0 00-.751-.755h-3.005a.753.753 0 00-.752.755v3.02c0 .417.337.755.752.755zm9.015-4.53h-3.005a.753.753 0 00-.751.755v3.02c0 .417.336.755.75.755h3.006a.753.753 0 00.751-.755v-3.02a.753.753 0 00-.75-.755zM18.228 61.274v-3.02a.753.753 0 00-.752-.755h-3.004a.753.753 0 00-.752.755v3.02c0 .417.336.755.752.755h3.004a.753.753 0 00.752-.755zm2.254-3.774a.753.753 0 00-.751.754v3.02c0 .417.336.755.75.755h3.006a.753.753 0 00.751-.755v-3.02a.753.753 0 00-.751-.755h-3.005zm6.01 0a.753.753 0 00-.752.754v3.02c0 .417.337.755.752.755h3.005a.753.753 0 00.751-.755v-3.02a.753.753 0 00-.75-.755h-3.006zm6.01 0a.753.753 0 00-.751.754v3.02c0 .417.336.755.751.755h3.005a.753.753 0 00.752-.755v-3.02a.753.753 0 00-.752-.755h-3.005zm6.01 0a.753.753 0 00-.751.754v3.02c0 .417.336.755.751.755h3.006a.753.753 0 00.75-.755v-3.02a.753.753 0 00-.75-.755h-3.006zm6.011 0a.753.753 0 00-.752.754v3.02c0 .417.336.755.752.755h3.005a.753.753 0 00.751-.755v-3.02a.753.753 0 00-.751-.755h-3.005zm6.01 0a.753.753 0 00-.751.754v3.02c0 .417.336.755.75.755h3.006a.753.753 0 00.751-.755v-3.02a.753.753 0 00-.75-.755h-3.006zm9.015 0h-3.006a.753.753 0 00-.75.754v3.02c0 .417.335.755.75.755h3.006a.753.753 0 00.751-.755v-3.02a.753.753 0 00-.751-.755zm-39.066 6.341h-3.006a.753.753 0 00-.75.755v3.02c0 .417.336.756.75.756h3.006a.753.753 0 00.751-.756v-3.02a.753.753 0 00-.751-.755zm6.01 0h-3.005a.753.753 0 00-.752.755v3.02c0 .417.337.756.752.756h3.005a.753.753 0 00.751-.756v-3.02a.753.753 0 00-.751-.755zm6.01 0h-3.005a.753.753 0 00-.751.755v3.02c0 .417.336.756.75.756h3.006a.753.753 0 00.752-.756v-3.02a.753.753 0 00-.752-.755zm6.01 0h-3.005a.753.753 0 00-.751.755v3.02c0 .417.336.756.75.756h3.006a.753.753 0 00.752-.756v-3.02a.753.753 0 00-.752-.755zm6.011 0h-3.006a.753.753 0 00-.751.755v3.02c0 .417.336.756.751.756h3.006a.753.753 0 00.751-.756v-3.02a.753.753 0 00-.751-.755zm6.01 0h-3.005a.753.753 0 00-.752.755v3.02c0 .417.337.756.752.756h3.005a.753.753 0 00.751-.756v-3.02a.754.754 0 00-.751-.755zm6.01 0h-3.005a.753.753 0 00-.751.755v3.02c0 .417.336.756.751.756h3.005a.753.753 0 00.751-.756v-3.02a.753.753 0 00-.751-.755zM52.035 73.96a.753.753 0 01-.751.754H22.735a.753.753 0 01-.75-.755v-3.02c0-.417.335-.755.75-.755h28.549c.415 0 .751.338.751.755v3.02z"
          fill="#FFF"
        />
        <path
          fill="#9C9C9C"
          d="M18.98 29.52v.907c0 5.754 4.641 10.42 10.367 10.42h15.326c5.726 0 10.368-4.666 10.368-10.42v-.906c0-.357-.019-.71-.053-1.058H19.032c-.035.348-.053.7-.053 1.058z"
        />
        <path
          fill="#000"
          d="M74.544 31.954c-.226 0-.449.016-.668.043-.519-2.48-2.539-4.41-5.056-4.78v-5.832c0-2.982-2.412-5.408-5.378-5.408h-.688V6.231c0-3.436-2.786-6.231-6.21-6.231H17.476c-3.424 0-6.21 2.795-6.21 6.231v9.746h-.688c-2.966 0-5.378 2.426-5.378 5.408v5.832c-2.93.431-5.187 2.975-5.187 6.04v46.329c0 3.366 2.723 6.104 6.07 6.104h61.854c3.347 0 6.07-2.738 6.07-6.104V47.598a5.45 5.45 0 005.98-5.416v-4.785a5.45 5.45 0 00-5.443-5.443zM63.442 18.6c1.519 0 2.755 1.25 2.755 2.785v5.767h-3.443V18.6h.688zM17.476 2.623h39.068c1.978 0 3.587 1.619 3.587 3.608v20.92H13.889V6.232c0-1.99 1.61-3.608 3.587-3.608zm3.908 27.152h1.502V36.8a9.162 9.162 0 01-1.502-2.04v-4.985zm3.305 0h1.503v9.188a9 9 0 01-1.503-.73v-8.458zm3.305 0h1.503v9.76h-.15c-.46 0-.91-.035-1.352-.102v-9.658zm3.306 0h1.503v9.76H31.3v-9.76zm3.306 0h1.503v9.76h-1.503v-9.76zm3.305 0h1.503v9.76h-1.503v-9.76zm3.306 0h1.503v9.76h-1.503v-9.76zm3.306 0h1.502v9.658a9.035 9.035 0 01-1.352.102h-.15v-9.76zm3.305 0h1.503v8.459a8.995 8.995 0 01-1.503.73v-9.19zm3.306 0h1.503v4.985a9.146 9.146 0 01-1.503 2.04v-7.025zM10.578 18.6h.688v8.552H7.823v-5.767c0-1.536 1.236-2.785 2.755-2.785zM6.083 83.067c-1.9 0-3.447-1.562-3.447-3.481v-46.33c0-1.92 1.546-3.481 3.447-3.481h11.585v.652c0 6.468 5.24 11.73 11.68 11.73h15.325c6.44 0 11.68-5.262 11.68-11.73v-.652h11.584c1.9 0 3.447 1.562 3.447 3.481v46.33c0 1.92-1.547 3.481-3.447 3.481H6.083zm71.281-40.885a2.823 2.823 0 01-3.357 2.767V34.63a2.823 2.823 0 013.357 2.768v4.784z"
        />
        <path
          fill="#000"
          d="M68.091 50.851c0-2.41-1.953-4.369-4.354-4.369H10.282c-2.4 0-4.353 1.96-4.353 4.369v24.168c0 2.41 1.953 4.37 4.353 4.37h53.455c2.4 0 4.354-1.96 4.354-4.37V50.851zm-2.623 24.168a1.74 1.74 0 01-1.73 1.746H10.281a1.74 1.74 0 01-1.73-1.746V50.851a1.74 1.74 0 011.73-1.746h53.455a1.74 1.74 0 011.73 1.746v24.168z"
        />
      </g>
    </svg>
  )
}

export function IconClose(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 47 47" {...props}>
      <path d="M46.5 4L42.9.5 23.5 19.9 4 .5.5 4l19.4 19.5L.5 42.9 4 46.5 23.5 27l19.4 19.5 3.6-3.6L27 23.5z" />
    </svg>
  )
}

export function LogoGiulianiHoenger(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 160.97 91" {...props}>
      <path d="M49.58 57.47c6.36 0 10.78 4.66 10.78 11.92S56 81.16 49.58 81.16 38.81 76.6 38.81 69.39s4.41-11.92 10.77-11.92zm0 20.41c4 0 6.74-3.18 6.74-8.54s-2.66-8.64-6.74-8.64-6.74 3.23-6.74 8.64 2.76 8.54 6.74 8.54zm-6.67-29.66h4v5.12h-4zm9.45 0h4v5.12h-4zM85.49 80.59h-3.94V67.44c0-4.89-1.8-6.5-5.12-6.5-3.8 0-6 3-6 6.6v13h-3.92V58h3.94v3.37a7.89 7.89 0 017.26-3.9c2.94 0 5.12 1 6.36 2.9a10.94 10.94 0 011.42 6.07zM96.05 81.54c.42 2.66 1.85 5.22 6.22 5.22 5.45 0 6.59-2.56 6.59-7.79V76.7c-1.09 2.27-3.8 3.94-7.26 3.94-5.94 0-10-4.28-10-11.49s4.27-11.68 10-11.68a8.28 8.28 0 017.21 3.85V58h3.94v21.21a15.2 15.2 0 01-1 6.17c-1.47 3.37-4.6 4.61-9.58 4.61-7 0-9.31-3.71-9.87-7.84zm6.26-20.79c-4 0-6.64 3.23-6.64 8.35s2.42 8.17 6.55 8.17 7-2.47 7-8.12-2.97-8.4-6.91-8.4zM139.7 75.94a11.5 11.5 0 01-10 5.22c-6.45 0-10.77-4.42-10.77-12 0-6.93 4.51-11.73 10.73-11.73 6.78 0 10.15 5.13 10.15 11.87v.85H123c.09 3.71 2.18 7.55 7.16 7.55a7.65 7.65 0 006.74-3.84zm-16.61-8.88h12.67c-.33-4-2.51-6.41-6.07-6.41s-6.17 2.47-6.6 6.41zM159 61.32a7.68 7.68 0 00-1.47-.14c-4.27 0-6.65 3.79-6.65 7.59v11.82h-3.93V58h3.93v4.27c.53-2.61 3.71-4.84 6.84-4.84a5 5 0 011.28.14zM32.34 80.59h-4.09V66h-19v14.59H5.19V48.31h4.1v14h19v-14h4.09zM42.05 6.9h-3.94v-5h3.94zm0 27.24h-3.94V11.55h3.94zM50.07 11.55H54v13a10 10 0 00.76 4.56c.81 1.57 2.23 2.14 4.37 2.14 3.79 0 5.74-3.09 5.74-6.74v-13h3.94v22.63h-3.93v-3.32c-1.23 2.18-3.42 3.89-7.22 3.89A7.33 7.33 0 0152 32.58c-1.43-1.62-2-3.23-2-8.17zM80.75 34.14h-3.83V1.87h3.83zM93.9 6.9H90v-5h3.9zm0 27.24H90V11.55h3.9zM121.51 34.47a11.22 11.22 0 01-2.23.19c-2.75 0-3.65-1.18-3.79-3-.71 1.18-2.71 3.13-7 3.13-4.6 0-7.69-2.47-7.69-6.84a5.7 5.7 0 012.9-5.26 20.15 20.15 0 016.6-1.95l3.08-.52c1.43-.24 1.9-.43 1.9-1.38v-.47c0-2.38-.76-4.08-4.8-4.08s-5.31 2.08-5.31 4.79l-3.8-.43c-.09-5.08 4.23-7.55 9.3-7.55s8.41 1.48 8.41 7.12v11.46c0 1.57.57 2 1.94 2h.52zm-6.26-11.81a14.71 14.71 0 01-2.61.66l-2.19.47a12.32 12.32 0 00-4.45 1.48 2.78 2.78 0 00-1.18 2.46c0 2.57 2 3.94 4.79 3.94s5.6-1.37 5.6-4.88zM147 34.14h-4V21c0-4.88-1.8-6.5-5.12-6.5-3.8 0-6 3-6 6.6v13.04H128V11.55h3.94v3.37a7.89 7.89 0 017.23-3.92c2.94 0 5.13 1 6.36 2.89A11 11 0 01147 20zM159 6.9h-4v-5h4zm0 27.24h-4V11.55h4zM24.41 27.81c1.14-1.66 1.71-3.6 1.76-6.93H15.06v-3.75h15v17h-3.94V30c-1.52 2.37-4.7 4.69-9.54 4.69C8 34.69 2 28.52 2 18 2 8.16 7.66 1.28 16.67 1.28a13.29 13.29 0 0112.44 7.36L25.6 11a9.32 9.32 0 00-8.93-6.07c-6.35 0-10.34 5.12-10.34 13s4 13.1 10.34 13.1c3.33.06 6.33-1.18 7.74-3.22z" />
    </svg>
  )
}

export function NavigationPlusSymbol(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 60 60" {...props}>
      <path d="M60 27.5H32.5V0h-5v27.5H0v5h27.5V60h5V32.5H60z" />
    </svg>
  )
}

export function InstagramIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46" {...props}>
      <path d="M23,0c-6.261,0-7.028,0-9.456.128A20.137,20.137,0,0,0,7.922,1.15,12.623,12.623,0,0,0,3.833,3.833,12.623,12.623,0,0,0,1.15,7.922,15.777,15.777,0,0,0,.128,13.544C0,15.972,0,16.739,0,23s0,7.028.128,9.456A20.137,20.137,0,0,0,1.15,38.078a12.623,12.623,0,0,0,2.683,4.089A11.945,11.945,0,0,0,7.922,44.85a15.777,15.777,0,0,0,5.622,1.022C15.972,46,16.739,46,23,46s7.028,0,9.456-.128a20.137,20.137,0,0,0,5.622-1.022,12.623,12.623,0,0,0,4.089-2.683,11.945,11.945,0,0,0,2.683-4.089,15.777,15.777,0,0,0,1.022-5.622C46,30.028,46,29.261,46,23s0-7.028-.128-9.456A20.137,20.137,0,0,0,44.85,7.922a12.623,12.623,0,0,0-2.683-4.089A12.623,12.623,0,0,0,38.078,1.15,15.777,15.777,0,0,0,32.456.128C30.028,0,29.261,0,23,0Zm0,4.089c6.133,0,6.9,0,9.328.128a10.942,10.942,0,0,1,4.217.894,8.513,8.513,0,0,1,2.683,1.661,6.385,6.385,0,0,1,1.661,2.683,15.394,15.394,0,0,1,.767,4.217c.128,2.428.128,3.194.128,9.328s0,6.9-.128,9.328a9.356,9.356,0,0,1-.767,4.217,7.3,7.3,0,0,1-1.661,2.683,6.385,6.385,0,0,1-2.683,1.661,15.394,15.394,0,0,1-4.217.767c-2.428.128-3.194.128-9.328.128s-6.9,0-9.328-.128a9.356,9.356,0,0,1-4.217-.767,7.3,7.3,0,0,1-2.683-1.661,5.939,5.939,0,0,1-1.661-2.683,10.942,10.942,0,0,1-.894-4.217C4.089,29.9,4.089,29.133,4.089,23s0-6.9.128-9.328a10.942,10.942,0,0,1,.894-4.217A8.513,8.513,0,0,1,6.772,6.772,6.385,6.385,0,0,1,9.456,5.111a10.942,10.942,0,0,1,4.217-.894C16.1,4.217,16.867,4.089,23,4.089Z" fillRule="evenodd" />
      <path d="M20.583,28.889a7.667,7.667,0,0,1,0-15.333h0a7.667,7.667,0,0,1,0,15.333Zm0-19.55a11.82,11.82,0,0,0-.128,23.639h0A11.861,11.861,0,0,0,32.339,21.094,11.724,11.724,0,0,0,20.583,9.339Zm15.206-.128A2.811,2.811,0,1,1,32.978,6.4a2.836,2.836,0,0,1,2.811,2.811" transform="translate(2.417 1.778)" fillRule="evenodd" />
    </svg>
  )
}

export function IconLinkArrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 50 50" {...props}>
      <g data-name="Desktop Pfeil zum Projekt">
        <g data-name="Group 11995">
          <path data-name="Path 12932" d="M49.401 35.201h-5.1l.1-26.6-40.9 40.8-3.5-3.5 40.9-40.9-26.7.1v-5.1l35.2.1z" />
        </g>
      </g>
    </svg>
  )
}

export function IconArrowLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 67.3 49.8" {...props}>
      <path d="M24.8 0l3.6 3.6L9.5 22.4h57.77v5H9.5l18.9 18.8-3.6 3.6L0 24.9z" />
    </svg>
  )
}

export function IconArrowRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 68.76 50.7" {...props}>
      <path d="M43.229 50.248l-3.6-3.6 18.9-18.8H.729v-5h57.8l-18.9-18.8 3.6-3.6 24.8 24.9z" />
    </svg>
  )
}

export function IconArrowDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 17.63 10.8" {...props}>
      <path d="M15.021.5l-6.2 6.2-6.2-6.2-1.8 1.8 8 8 8-8-1.8-1.8z" />
    </svg>
  )
}

export function IconArrowUp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 17.63 10.8" {...props}>
      <path d="M8.819.5l-8 8 1.8 1.8 6.2-6.2 6.2 6.2 1.8-1.8-8-8z" />
    </svg>
  )
}

export function IconLine(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="11px" height="3px" viewBox="0 0 11 3" version="1.1" {...props}>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Mobile-Symbol-absteigend" transform="translate(0.000000, 1.000000)" stroke="#222222" strokeWidth="2.5">
          <line x1="0.5" y1="0.5" x2="10.5" y2="0.5" id="Line"></line>
        </g>
      </g>
    </svg>
  )
}

export function IconMore(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="31.8" height="5" version="1.1" {...props}>
      <g data-name="Laptop Mobile More Symbol">
        <g data-name="Gruppe 12067">
          <g data-name="Gruppe 12064">
            <path data-name="Rechteck 435" d="M5 0v5H0V0z" />
          </g>
          <g data-name="Gruppe 12065">
            <path data-name="Rechteck 436" d="M18.4 0v5h-5V0z" />
          </g>
          <g data-name="Gruppe 12066">
            <path data-name="Rechteck 437" d="M31.8 0v5h-5V0z" />
          </g>
        </g>
      </g>
    </svg>
  )
}

export function IconChevronRight(props: React.SVGProps<SVGSVGElement>){
  return(
    <svg viewBox="0 0 10 17" {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon fill="#000000" fillRule="nonzero" transform="translate(5, 8.9) rotate(90) translate(-5, -8.9) " points="5 4 -3 12 -1.2 13.8 5 7.6 11.2 13.8 13 12"></polygon>
    </g>
</svg>
//  <svg viewBox="0 0 9.8 16" {...props}>
// <g transform="translate(5 8.9) rotate(90) translate(-5 -8.9)">
//   <path d="M7.979,0l-8,8,1.8,1.8,6.2-6.2,6.2,6.2,1.8-1.8Z" />
// </g>
// </svg> 
  )
}

export function IconChevronDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 9.8" {...props}>
      <g transform="translate(16 9.8) rotate(180)">
        <path d="M7.979,0l-8,8,1.8,1.8,6.2-6.2,6.2,6.2,1.8-1.8Z" />
      </g>
    </svg>
  )
}

export function IconChevronUp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 9.8" {...props}>
      <g>
        <path d="M7.979,0l-8,8,1.8,1.8,6.2-6.2,6.2,6.2,1.8-1.8Z" />
      </g>
    </svg>
  )
}

export function Icon404(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="576.157" height="1234.846" viewBox="0 0 576.157 1234.846">
      <g id="Komponente_11_1" data-name="Komponente 11 – 1" transform="translate(2 2)">
        <path
          id="Pfad_12964"
          data-name="Pfad 12964"
          d="M2486.9,520.533V-712.313h572.157V520.533"
          transform="translate(-2486.896 712.313)"
          fill="#fff"
          stroke="#1d1d1b"
          stroke-miterlimit="10"
          stroke-width="4"
        />
        <g id="Gruppe_12005" data-name="Gruppe 12005" transform="translate(52.145 635.227)">
          <rect
            id="Rechteck_403"
            data-name="Rechteck 403"
            width="66.903"
            height="106.343"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_404"
            data-name="Rechteck 404"
            width="66.903"
            height="106.343"
            transform="translate(133.655)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_405"
            data-name="Rechteck 405"
            width="66.903"
            height="106.343"
            transform="translate(267.31)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_406"
            data-name="Rechteck 406"
            width="66.903"
            height="106.343"
            transform="translate(400.965)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
        <g id="Gruppe_12006" data-name="Gruppe 12006" transform="translate(52.145 470.469)">
          <rect
            id="Rechteck_407"
            data-name="Rechteck 407"
            width="66.903"
            height="106.343"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_408"
            data-name="Rechteck 408"
            width="66.903"
            height="106.343"
            transform="translate(133.655)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_409"
            data-name="Rechteck 409"
            width="66.903"
            height="106.343"
            transform="translate(267.31)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_410"
            data-name="Rechteck 410"
            width="66.903"
            height="106.343"
            transform="translate(400.965)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
        <g id="Gruppe_12007" data-name="Gruppe 12007" transform="translate(52.145 305.712)">
          <rect
            id="Rechteck_411"
            data-name="Rechteck 411"
            width="66.903"
            height="106.343"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_412"
            data-name="Rechteck 412"
            width="66.903"
            height="106.343"
            transform="translate(133.655)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_413"
            data-name="Rechteck 413"
            width="66.903"
            height="106.343"
            transform="translate(267.31)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_414"
            data-name="Rechteck 414"
            width="66.903"
            height="106.343"
            transform="translate(400.965)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
        <g id="Gruppe_12008" data-name="Gruppe 12008" transform="translate(52.145 140.955)">
          <rect
            id="Rechteck_415"
            data-name="Rechteck 415"
            width="66.903"
            height="106.343"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_416"
            data-name="Rechteck 416"
            width="66.903"
            height="106.343"
            transform="translate(133.655)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_417"
            data-name="Rechteck 417"
            width="66.903"
            height="106.343"
            transform="translate(267.31)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_418"
            data-name="Rechteck 418"
            width="66.903"
            height="106.343"
            transform="translate(400.965)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
        <g id="Gruppe_12009" data-name="Gruppe 12009" transform="translate(52.145 799.984)">
          <rect
            id="Rechteck_419"
            data-name="Rechteck 419"
            width="66.903"
            height="106.343"
            transform="translate(0 0)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_420"
            data-name="Rechteck 420"
            width="66.903"
            height="106.343"
            transform="translate(133.655 0)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_421"
            data-name="Rechteck 421"
            width="66.903"
            height="106.343"
            transform="translate(267.31 0)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_422"
            data-name="Rechteck 422"
            width="66.903"
            height="106.343"
            transform="translate(400.965 0)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
        <g id="Gruppe_12010" data-name="Gruppe 12010" transform="translate(52.145 964.741)">
          <rect
            id="Rechteck_423"
            data-name="Rechteck 423"
            width="66.903"
            height="106.343"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_424"
            data-name="Rechteck 424"
            width="66.903"
            height="106.343"
            transform="translate(133.655)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_425"
            data-name="Rechteck 425"
            width="66.903"
            height="106.343"
            transform="translate(267.31)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <rect
            id="Rechteck_426"
            data-name="Rechteck 426"
            width="66.903"
            height="106.343"
            transform="translate(400.965)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
        <g id="Gruppe_12011" data-name="Gruppe 12011" transform="translate(52.145 1129.499)">
          <path
            id="Pfad_12965"
            data-name="Pfad 12965"
            d="M2533.2,394.122V290.775h66.9V394.122"
            transform="translate(-2533.205 -290.775)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12966"
            data-name="Pfad 12966"
            d="M2651.9,394.122V290.775h66.9V394.122"
            transform="translate(-2518.246 -290.775)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12967"
            data-name="Pfad 12967"
            d="M2770.6,394.122V290.775h66.9V394.122"
            transform="translate(-2503.288 -290.775)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12968"
            data-name="Pfad 12968"
            d="M2889.294,394.122V290.775h66.9V394.122"
            transform="translate(-2488.33 -290.775)"
            fill="#cc9f26"
            stroke="#1d1d1b"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
        <g id="Gruppe_12012" data-name="Gruppe 12012" transform="translate(53.019 184.391)">
          <path
            id="Pfad_12971"
            data-name="Pfad 12971"
            d="M2533.981-490.345v-20.969H2555.7"
            transform="translate(-2533.981 553.253)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12972"
            data-name="Pfad 12972"
            d="M2572.556-527.59v-20.969h21.718"
            transform="translate(-2529.12 548.559)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12973"
            data-name="Pfad 12973"
            d="M2553.269-508.968v-20.969h21.718"
            transform="translate(-2531.551 550.906)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
        <g id="Gruppe_12013" data-name="Gruppe 12013" transform="translate(186.674 678.663)">
          <path
            id="Pfad_12974"
            data-name="Pfad 12974"
            d="M2652.678-51.391V-72.36H2674.4"
            transform="translate(-2652.678 114.298)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12975"
            data-name="Pfad 12975"
            d="M2691.253-88.636V-109.6h21.718"
            transform="translate(-2647.817 109.605)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12976"
            data-name="Pfad 12976"
            d="M2671.965-70.013V-90.983h21.718"
            transform="translate(-2650.247 111.952)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
        <g id="Gruppe_12014" data-name="Gruppe 12014" transform="translate(53.019 843.42)">
          <path
            id="Pfad_12977"
            data-name="Pfad 12977"
            d="M2533.981,94.927V73.958H2555.7"
            transform="translate(-2533.981 -32.02)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12978"
            data-name="Pfad 12978"
            d="M2572.556,57.682V36.713h21.718"
            transform="translate(-2529.12 -36.713)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12979"
            data-name="Pfad 12979"
            d="M2553.269,76.3V55.336h21.718"
            transform="translate(-2531.551 -34.366)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
        <g id="Gruppe_12015" data-name="Gruppe 12015" transform="translate(186.674 349.148)">
          <path
            id="Pfad_12980"
            data-name="Pfad 12980"
            d="M2712.97-344.027V-365h-21.718"
            transform="translate(-2647.817 406.935)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12981"
            data-name="Pfad 12981"
            d="M2674.4-381.272v-20.969h-21.718"
            transform="translate(-2652.678 402.241)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12982"
            data-name="Pfad 12982"
            d="M2693.683-362.65v-20.969h-21.718"
            transform="translate(-2650.247 404.588)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
        <g id="Gruppe_12016" data-name="Gruppe 12016" transform="translate(186.674 1008.139)">
          <path
            id="Pfad_12983"
            data-name="Pfad 12983"
            d="M2712.97,241.211V220.242h-21.718"
            transform="translate(-2647.817 -178.304)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12984"
            data-name="Pfad 12984"
            d="M2674.4,203.967V183h-21.718"
            transform="translate(-2652.678 -182.997)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12985"
            data-name="Pfad 12985"
            d="M2693.683,222.589V201.62h-21.718"
            transform="translate(-2650.247 -180.651)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
        <g id="Gruppe_12017" data-name="Gruppe 12017" transform="translate(320.329 513.906)">
          <path
            id="Pfad_12986"
            data-name="Pfad 12986"
            d="M2831.667-197.709v-20.969h-21.718"
            transform="translate(-2766.513 260.617)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12987"
            data-name="Pfad 12987"
            d="M2793.092-234.954v-20.969h-21.718"
            transform="translate(-2771.374 255.923)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12988"
            data-name="Pfad 12988"
            d="M2812.38-216.331V-237.3h-21.718"
            transform="translate(-2768.944 258.27)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
        <g id="Gruppe_12018" data-name="Gruppe 12018" transform="translate(320.329 1167.687)">
          <path
            id="Pfad_12989"
            data-name="Pfad 12989"
            d="M2831.667,382.9V361.934h-21.718"
            transform="translate(-2766.513 -319.995)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12990"
            data-name="Pfad 12990"
            d="M2793.092,345.658V324.689h-21.718"
            transform="translate(-2771.374 -324.689)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
          <path
            id="Pfad_12991"
            data-name="Pfad 12991"
            d="M2812.38,364.28V343.311h-21.718"
            transform="translate(-2768.944 -322.342)"
            fill="none"
            stroke="#1d1d1b"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="4"
          />
        </g>
      </g>
    </svg>
  )
}
